export function eraseCookie(name: string): void {
  let valueWithOpts =
    name + "=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  if (!window.location.hostname.includes("localhost")) {
    valueWithOpts += "; domain=.freshpaint.io";
  }
  document.cookie = valueWithOpts;
}
